import React from 'react';

// `state` drives the step marker: done = plain, active = filled blue with the "You are here" pill,
// next = dashed outline for the stage that isn't live yet.
const STAGES = [
    { n: '1', state: 'done', title: 'Seed', body: 'Angel networks and early companies onboard to Diligentsia.' },
    { n: '2', state: 'done', title: 'Venture Capital', body: 'VCs and advisors keep company records diligenced as they scale.' },
    { n: '3', state: 'active', title: 'Private Equity', body: "Qualified dealflow and target-company diligence, delivered with Morsebridge's platform layer." },
    { n: '4', state: 'next', title: 'PISCES / Exit', body: 'Portfolio companies kept exit-ready for trade sale, secondary or PISCES.' },
];

const PELifecycleSection = () => (
    <section className="lp-pe-lifecycle">
        <div className="lp-pe-lifecycle-inner">
            <div>
                <span className="lp-pe-eyebrow lp-pe-eyebrow--muted" data-lp-reveal>The Diligentsia lifecycle</span>
                <h2 className="lp-pe-h2" data-lp-reveal data-lp-delay="60">We stay with the company, not just the round.</h2>
                <p className="lp-pe-lifecycle-lede" data-lp-reveal data-lp-delay="120">Diligentsia already works with seed-stage companies, angel networks, VCs and advisors. That means some of dealflow reaching PE houses through our platform may have been in diligenced hands for years before it lands with you.</p>
                <div className="lp-pe-coming" data-lp-reveal data-lp-delay="160">
                    <span>Coming next</span>
                    <p>We're extending the platform to bring VC-sourced opportunities — follow-on funding rounds, secondaries and PISCES-ready companies — direct to PE houses looking for their next thesis-fit deal.</p>
                </div>
            </div>

            <div className="lp-pe-stages">
                {STAGES.map((s, i) => (
                    <div className={`lp-pe-stage${i === STAGES.length - 1 ? ' is-last' : ''}`} key={s.n} data-lp-reveal data-lp-delay={i * 80}>
                        <div className={`lp-pe-stage-num is-${s.state}`}>{s.n}</div>
                        {i < STAGES.length - 1 && <div className="lp-pe-stage-line" aria-hidden="true" />}
                        <div>
                            <div className="lp-pe-stage-title">
                                {s.title}
                                {s.state === 'active' && <span className="lp-pe-stage-here">You are here</span>}
                            </div>
                            <p>{s.body}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default PELifecycleSection;
